import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"

import TimeAgo from "react-timeago"
import polandStrings from "react-timeago/lib/language-strings/pl"
import buildFormatter from "react-timeago/lib/formatters/buildFormatter"

const DateAgoHelper = (props) => {
    const formatter = buildFormatter(polandStrings)
    const [dateAgo, setDateAgo] = useState(new Date())

    useEffect(() => {
        if (props.date)
            setDateAgo(new Date(Date.parse(props.date)))
        else
            setDateAgo(new Date())
    }, [props]);

    return (
        <>
            <TimeAgo date={dateAgo} formatter={formatter}/>
        </>
    )
}

DateAgoHelper.propTypes = {
    date: PropTypes.string
}
export default DateAgoHelper
